import { useMutation } from "@tanstack/react-query";


import { useToast } from "../../../Services/ToastContext";
import { ResendCodeRegisterRequest } from "../../../interface/IRegister";
import { GeneralResponse } from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { Methods } from "../../../Constants/ApiConstants";
import { EndPoints } from "../../../Constants/endpoints";

const useResendCodeRegister = () => {
  const { showToast } = useToast();
  const mutation = useMutation({
    mutationFn: (data: ResendCodeRegisterRequest): Promise<GeneralResponse> => {
      return Api<ResendCodeRegisterRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.ResendCode,
        body: data,
      });
    },
    onSuccess: (data) => {
      return;
    },
    onError: (error: any) => {
      showToast(error.response?.data?.message || error.message, "error");
    },
  });

  return mutation;
};

export default useResendCodeRegister;
